const translations = {
  en: {
    emailLabel: "Email Address",
    passwordLabel: "Password",
    passwordConfLabel: "Password Confirmation",
    verificationLabel: "Verify",
    verificationCodeLabel: "Verification Code",
    loginButton: "LOGIN",
    signupPrompt: "Not a member?",
    forgetPassword: "Forget Password",
    signupLabel: "SIGN UP",
    emailInvalid: "Email is invalid",
    emailEmpty: "Email can't be empty",
    passwordEmpty: "Password can't be empty",
    lockedAccount: "Your account is locked. Please contact admin",
    wrongEmail: "Incorrect Email or password",
    wrongPassword: "Incorrect Email or password",
    wrongEmailVerif: "Incorrect Email or verification code",
    wrongCodeVerif: "Incorrect Email or verification code",
    passwordAndPasswordConf: "Password and Password Confirmation do not match",
    paswordConfReq: "Password Confirmation is required",
    realNameReq: "Real Name is required",
    phoneReq: "Phone Number is required",
    loading: "Loading",
    emailNotAvail: "Email is not available",
    emailAvail: "Email is available",
    realName: "Real Name",
    phoneNum: "Phone Number",
    submitLabel: "SUBMIT",
    loginPrompt: "Already a member?",
    resendVerification: "Resend Verifiation Code",
    sendVerification: "Send Verifiation Code",
    checkEmailAndSpam: "Check your Email and spam folder",
    toastNewMem: "Account created. Please login",
    toastNewPass: "Password changed. Please login",
  },
  id: {
    emailLabel: "Alamat Email",
    passwordLabel: "Kata Sandi",
    passwordConfLabel: "Konfirmasi Kata Sandi",
    verificationLabel: "Verifikasi",
    verificationCodeLabel: "Kode Verifikasi",
    loginButton: "MASUK",
    signupPrompt: "Belum memiliki akun?",
    forgetPassword: "Lupa Kata Sandi",
    signupLabel: "DAFTAR",
    emailInvalid: "Email tidak valid",
    emailEmpty: "Email tidak boleh kosong",
    passwordEmpty: "Password tidak boleh kosong",
    lockedAccount: "Akun anda terkunci. Mohon hubungi admin",
    wrongEmail: "Email atau password salah",
    wrongPassword: "Email atau password salah",
    wrongEmailVerif: "Email atau kode verifikasi salah",
    wrongCodeVerif: "Email atau kode verifikasi salah",
    passwordAndPasswordConf: "Password dan Konfirmasi Password tidak sama",
    paswordConfReq: "Konfirmasi Password tidak boleh kosong",
    realNameReq: "Nama Asli tidak boleh kosong",
    phoneReq: "Nomor Telepon tidak boleh kosong",
    loading: "Memuat",
    emailNotAvail: "Email tidak tersedia",
    emailAvail: "Email tersedia",
    realName: "Nama Asli",
    phoneNum: "Nomor Telepon",
    submitLabel: "KIRIM",
    loginPrompt: "Sudah punya akun?",
    resendVerification: "Kirim ulang Kode Verifikasi",
    sendVerification: "Kirim Kode Verifikasi",
    checkEmailAndSpam: "Periksa email Anda. Periksa juga folder spam",
    toastNewMem: "Akun telah berhasil dibuat. Silahan masuk",
    toastNewPass: "Kata Sandi berhasil diubah. Silahkan masuk",
  },
};

export default translations;